import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const howSteps = [
  {
    label: "Build Your Map",
    text: "Break Domains into Skills → Subskills → Microskills."
  },
  {
    label: "Generate Questions",
    text: "Instantly with AI or add them manually."
  },
  {
    label: "Train With Feedback",
    text: "Fluency, one rep at a time."
  },
  {
    label: "Audit Performance",
    text: "Track strengths and gaps as you train."
  },
  {
    label: "See Your Thinking",
    text: "Mindzera maps and grows with you like a living cognitive system."
  }
];

export default function HowBanner() {
  const [index, setIndex] = useState(0);
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % howSteps.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const current = howSteps[index];

  return (
    <div className="text-center px-4 pb-8 -mt-4">
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={index}
          initial={{ opacity: 0, y: hasMounted ? 10 : 0 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.6 }}
          className="text-base md:text-lg text-gray-800 flex justify-center items-center gap-2"
        >
          <motion.span
            key={`number-${index}`}
            initial={{ opacity: 0, x: -6 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 6 }}
            transition={{ duration: 0.4 }}
            className="text-blue-600 font-bold"
          >
            {index + 1}.
          </motion.span>
          <span className="font-semibold text-gray-900">{current.label}:</span>{" "}
          <span className="font-normal text-gray-700">{current.text}</span>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
